module.exports = __webpack_public_path__ + "img/product_5.660511c.jpg";